module.exports = __webpack_public_path__ + "img/drama_popup_bottom.62852d26.png";